// OLA - Offline Leads Actions

import type { OlaApiContract, ResponseUserOfflinePurchases, ResponseValidateHash } from "@jti/rest-api-types";

import { Rest } from "../../Rest";

/** @deprecated Legacy proxy implementation — superseded by EVO. To be deleted after production verification. */
export class OlaApiLegacy extends Rest implements OlaApiContract {
  constructor(
    baseUrl: string,
    protected tenantToken: string,
    protected ciamToken: string,
    protected userUuid: string
  ) {
    super(baseUrl);
    this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
    this.ciamToken && this.setCommonHeader("X-DES-CONSUMER-IAM-TOKEN", this.ciamToken);
  }

  async getOfflinePurchases(): Promise<ResponseUserOfflinePurchases> {
    return this.request(
      `/consumers/${this.userUuid}/actions/purchase`,
      {
        method: "GET",
      },
      true
    );
  }

  async validateHash(hash: string): Promise<ResponseValidateHash> {
    return this.request(
      `/consent/validate/${hash}`,
      {
        method: "POST",
      },
      true
    );
  }
}
